const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-upload-cloud",
  "data-name": "Icon feather-upload-cloud",
  transform: "translate(-0.31 -3.479)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2415",
  "data-name": "Path 2415",
  d: "M21.5,22.749,16.749,18,12,22.749",
  transform: "translate(-2.191 -2.814)",
  fill: "none",
  stroke: "#008941",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2416",
  "data-name": "Path 2416",
  d: "M18,18V28.685",
  transform: "translate(-3.442 -2.814)",
  fill: "none",
  stroke: "#008941",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2417",
  "data-name": "Path 2417",
  d: "M24.519,22.772a5.936,5.936,0,0,0-2.838-11.148h-1.5A9.5,9.5,0,1,0,3.873,20.291",
  transform: "translate(0)",
  fill: "none",
  stroke: "#008941",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2418",
  "data-name": "Path 2418",
  d: "M21.5,22.749,16.749,18,12,22.749",
  transform: "translate(-2.191 -2.814)",
  fill: "none",
  stroke: "#008941",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));
function SvgIconfeatherUploadCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.381,
    height: 23.393,
    viewBox: "0 0 28.381 23.393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfeatherUploadCloud);
export default __webpack_public_path__ + "static/media/Icon feather-upload-cloud.b28e2352.svg";
export { ForwardRef as ReactComponent };